

import { onUnmounted, ref } from '@vue/composition-api'
import {FilterServices} from './services'

export default function filter(col_name) {


  const areasOwnersOptions = ref([])
  const areasContractsOptions = ref([])
  const areasCategoriesOptions = ref([])
  const areasContractsOptions_orig=ref([])




  FilterServices.getFilterOptionsBy(col_name)
  
    .then(response => {
     
      const { 
      categories, contracts, owners} = response.data.data
      areasOwnersOptions.value = owners
      areasContractsOptions.value = contracts
      areasContractsOptions_orig.value=contracts
      areasCategoriesOptions.value = categories
     
    




    })


  return {
    areasOwnersOptions,
   
    areasCategoriesOptions,
    areasContractsOptions,
    areasContractsOptions_orig,


  }

}
